//region block: pre-declaration
//endregion
function initCauseBridge(_this__u8e3s4, cause) {
}
//region block: exports
export {
  initCauseBridge as initCauseBridge1upxfqhavblt6,
};
//endregion

//# sourceMappingURL=ExceptionUtils.web.mjs.map
